import { Color } from "@repo/app-types/constants/colors";
import type { CustomField } from "@repo/app-types/entities/customField";
import { CustomFieldType } from "@repo/app-types/entities/customField";
import { Size } from "@repo/ui/helpers/helpers";
import { AutoLink } from "@repo/ui/Link/autoLink";
import { Pill } from "@repo/ui/Pills/pill";
import type { FC } from "react";
import { formatCustomFieldDateValue } from "../../../helpers/customFieldFormatting.js";

export interface CustomFieldValueProps {
  field: CustomField;
  disregardDisplayValue?: boolean;
}

export const CustomFieldValue: FC<CustomFieldValueProps> = (props) => {
  const { field, disregardDisplayValue } = props;

  if (field.data.value === null) {
    return <span className="text-gray-400">--</span>;
  }

  // Sometimes we may want to not use the display value.
  // For data extracted custom fields for example
  if (field.data.display_value && !disregardDisplayValue) {
    return field.data.display_value;
  }

  switch (field.field_type) {
    case CustomFieldType.Boolean:
      return (
        <Pill
          label={field.data.value ? "Yes" : "No"}
          size={Size.SMALL}
          color={field.data.value ? Color.Green : Color.Red}
        />
      );

    case CustomFieldType.Date:
    case CustomFieldType.DateAndTime:
      return formatCustomFieldDateValue(field.field_type, field.data.value);

    default:
      return <AutoLink>{String(field.data.value)}</AutoLink>;
  }
};
